import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Col,
  Row,
  Container,
  Jumbotron,
  Button,
  HeadingTwo,
  HeadingFour,
  getThumborURL
} from 'hui';
import { EventCategories, EventActions, EventLabels } from '../../constants/Analytics';
import { getArticleImageMediaQueriesObject } from './utils';
import defaultArticleImage from './images/default-article.png';

const ColHero = styled(Col)`
  margin-top: 10px;

  // ie10
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    min-width: 140px;
  }
  a {
    min-width: 100px;
    padding: 12px 10px;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      padding: 12px 20px;
    }
  }
`;

const StyledJumbotron = styled(Jumbotron)`
  height: 80vh;
  min-height: 340px;
  max-height: 500px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const ResponsiveContainer = styled(Container)`
  width: 100%;
`;

const getCorrectImageForMedia = images => {
  const breakpoints = {
    375: 'xs',
    480: 'sm',
    768: 'md'
  };
  const width = window.innerWidth;
  const bp =
    breakpoints[
      ((Object.keys(breakpoints) as unknown) as number[]).find((bp: number) => width <= bp)
    ] || 'lg';
  return images[bp];
};

export default class HeroJumbotronTradie extends Component<any, any> {
  static propTypes = {
    heroImage: PropTypes.string
  };

  static defaultProps = {
    heroImage: defaultArticleImage
  };

  componentDidMount() {
    if (typeof Image === 'undefined') {
      return;
    }

    const image = new Image();
    const src = getCorrectImageForMedia(getArticleImageMediaQueriesObject(this.props.heroImage));
    image.onload = () => this.setState({ bgImage: src });
    image.src = src;
  }

  state = {
    bgImage: `'${getThumborURL(this.props.heroImage, '30x0', 'smart', 'blur(2)')}'`
  };

  render() {
    const { bgImage } = this.state;
    return (
      <div>
        <StyledJumbotron
          background={bgImage}
          style={{ transition: 'background-image 0.5s ease-in' }}
        >
          <ResponsiveContainer>
            <Row>
              <Col xs={12}>
                <HeadingTwo mb={1} mt={0} align="center">
                  Are you a trade business looking for more jobs?
                </HeadingTwo>
                <HeadingFour align="center">Let us send the customers to you</HeadingFour>
              </Col>
            </Row>
            <Row justifyContent="center">
              <ColHero xs={12} md={6}>
                <Button
                  tag="a"
                  href="/advertise"
                  target="_blank"
                  color="primary"
                  block
                  data-ga-category={EventCategories.ARTICLES}
                  data-ga-action={EventActions.GET_QUOTES_TRADE_HERO_CLICK_BUTTON}
                  data-ga-label={EventLabels.GET_QUOTES_TRADE_HERO_CLICK_BUTTON}
                >
                  Learn More
                </Button>
              </ColHero>
            </Row>
          </ResponsiveContainer>
        </StyledJumbotron>
      </div>
    );
  }
}
